import * as React from 'react';
import Select, {
	SelectValue,
} from '../../../../../Components/Base/Select/Select';
import { useTermItemsQuery } from '../../../../../graphql/graphql';
import { FieldError } from 'react-hook-form';
import { useMemo, useState } from 'react';
import Loading from '../../../../../Components/Loading';
import useTranslation from '../../../../../Hooks/useTranslation';
import { createFilter } from 'react-select';

interface Props {
	onChange?: (value: SelectValue) => void;
	value?: SelectValue | string;
	error?: FieldError;
}

const ArchivationReasonSelect: React.FC<Props> = props => {
	const { value, onChange } = props;
	const { data, isLoading } = useTermItemsQuery({
		termType: 'archivation_reason',
		take: 999,
	});
	const [defaultValue, setDefaultValue] = useState(value);
	const { t } = useTranslation();

	const options: SelectValue[] = useMemo(() => {
		const items: SelectValue[] = [];

		for (const termItem of data?.termItems?.data || []) {
			if (termItem?.value && termItem?.name) {
				items.push({
					value: termItem.value,
					label: termItem.name,
					item: termItem,
				});
			}
		}

		return items;
	}, [data]);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<Select
			options={options}
			{...props}
			onChange={onChange}
			placeholder={t('base.shared.pick')}
			value={typeof defaultValue === 'string' ? value : defaultValue}
			filterOption={createFilter({
				stringify: option => `${option.label}`,
			})}
			isSearchable
		/>
	);
};

export default ArchivationReasonSelect;
